import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MainLayout from "../../src/components/layout/MainLayout";
import Breadcrumbs from "../../src/components/common/Breadcrumbs";
import SuicideDetailList from "./Residential/Optional/SuicideDetail/SuicideDetailList";

import {
    fetchSuicideDetails,
    deleteSuicideDetail,
} from "../store/slices/suicideDetailsSlice"

const SuicideDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {
        suicideDetails,
        isLoading,
    } = useSelector((state) => state.suicideDetails);

    // ==================== Fetch Records ====================
    useEffect(() => {
        dispatch(fetchSuicideDetails());
    }, [dispatch]);

    // ==================== Handlers ====================
    const handleAdd = () => {
        navigate("/residential/optional/suicide-detail/add");
    };

    const handleEdit = (id) => {
        navigate(`/residential/optional/suicide-detail/edit/${id}`);
    };

    const handleDelete = async (id) => {
        await dispatch(deleteSuicideDetail(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <SuicideDetailList
                            records={suicideDetails}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default SuicideDetails;
